module.exports = __webpack_public_path__ + "img/mt.b13e8025.png";